import { HTTPResponse } from '@/class/HTTPResponse';

const getBaseUrl = (): string => process.env.REACT_APP_API_ENDPOINT || 'http://localhost:8000/api';

const parseResponse = async (response: Response): Promise<HTTPResponse> => {
  const body = await response.json().catch(() => ({}));
  return {
    ...body,
    status: response.status,
  };
};

export const requestPasswordReset = async (email: string): Promise<HTTPResponse> => {
  const url = `${getBaseUrl()}/store/password-reset/request`;
  const response = await fetch(url, {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ email }),
  });

  return parseResponse(response);
};

export const verifyPasswordResetToken = async (token: string): Promise<HTTPResponse> => {
  const params = new URLSearchParams({ token });
  const url = `${getBaseUrl()}/store/password-reset/verify?${params.toString()}`;
  const response = await fetch(url, {
    headers: {
      Accept: 'application/json',
    },
  });

  return parseResponse(response);
};

export const resetPassword = async (
  token: string,
  password: string,
  passwordConfirmation: string,
): Promise<HTTPResponse> => {
  const url = `${getBaseUrl()}/store/password-reset/reset`;
  const response = await fetch(url, {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      token,
      password,
      password_confirmation: passwordConfirmation,
    }),
  });

  return parseResponse(response);
};
